import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <div className="px-4 md:px-6 flex flex-col items-center text-center space-y-8">
        <div className="space-y-4">
          <h1 className="text-7xl md:text-9xl font-bold text-gray-900">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-600">
            Page not found
          </h2>
          <p className="max-w-[600px] text-gray-500">
            Oops! The page you're looking for seems to have vanished into thin air. 
            Let's get you back on track.
          </p>
        </div>

        <Link 
          to="/" 
          className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200"
        >
          <svg 
            className="w-4 h-4 mr-2" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" 
            />
          </svg>
          Return Home
        </Link>
      </div>
    </div>
  );
}